import {
  BUY_BUTTON_SET_ARTICLE_NUMBER,
  BUY_BUTTON_SET_LOADING,
} from '../constants';

export const setBuyButtonArticleNumber = (articleNumber: string) => ({
  type: BUY_BUTTON_SET_ARTICLE_NUMBER,
  payload: {
    articleNumber,
  },
});

export const setBuyButtonLoading = (isLoading: boolean) => ({
  type: BUY_BUTTON_SET_LOADING,
  payload: {
    isLoading,
  },
});
